import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";

import { DisclaimerComponent } from "./disclaimer/disclaimer.component";
import { QuestionsComponent } from "./questions/questions.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { CheckoutFooterComponent } from "./checkout/checkout.component";
import brandInfo from "src/environments/brand.json";

@Component({
  selector: "app-footer",
  standalone: true,
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  imports: [DisclaimerComponent, QuestionsComponent, ContactUsComponent, CheckoutFooterComponent]
})
export class FooterComponent implements OnInit {
  isCheckoutPage = false;
  isWidget = false;

  constructor(private router: Router, private location: Location) {}

  get isNCESICart() {
    return brandInfo.brand === 'NCESI' && this.router.url === '/cart';
  }

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url === "/checkout") {
        this.isCheckoutPage = true;
      } else {
        this.isCheckoutPage = false;
      }
    });

    // If widget, hide nav
    if (this.location.path().includes("widget")) {
      this.isWidget = true;
    }
  }
}
